import { api } from '../../../lib/api.js';

export async function fetchMyStep() {
  const res = await api.request({ url: 'mystep', method: 'GET' });
  return res.data;
}

export async function fetchDetailedReport() {
  const res = await api.request({ url: 'detailreportV1', method: 'GET' });
  return res.data;
}
